'use client'

import { useFormState, useFormStatus } from 'react-dom'
import { login } from '@/app/actions/auth'

function SubmitButton() {
  const { pending } = useFormStatus()
  return (
    <button
      type="submit"
      disabled={pending}
      className="w-full py-2.5 rounded-lg text-white text-sm font-semibold transition-opacity disabled:opacity-60"
      style={{ background: '#185FA5' }}
    >
      {pending ? '로그인 중...' : '로그인'}
    </button>
  )
}

export default function LoginPage() {
  const [state, formAction] = useFormState(login, null)

  return (
    <main className="min-h-screen flex items-center justify-center" style={{ background: '#F4F2EB' }}>
      <div className="w-full max-w-sm px-4">
        <div className="text-center mb-8">
          <div
            className="inline-flex items-center justify-center w-12 h-12 rounded-xl text-white font-bold text-lg mb-3"
            style={{ background: 'linear-gradient(135deg,#1D9E75,#0F6E56)' }}
          >B</div>
          <h1 className="text-2xl font-bold" style={{ color: '#2C2C2A' }}>Bricks Classroom</h1>
          <p className="text-sm mt-1" style={{ color: '#67645B' }}>교사 로그인</p>
        </div>

        <div className="rounded-xl p-6" style={{ background: '#fff', border: '1px solid #E5E2D9' }}>
          <form action={formAction} className="space-y-4">
            <div className="space-y-1.5">
              <label htmlFor="email" className="block text-sm font-medium" style={{ color: '#2C2C2A' }}>이메일</label>
              <input id="email" name="email" type="email" required placeholder="teacher@school.com"
                className="w-full px-3 py-2 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                style={{ borderColor: '#E5E2D9', background: '#F8F8F5' }} />
            </div>
            <div className="space-y-1.5">
              <label htmlFor="password" className="block text-sm font-medium" style={{ color: '#2C2C2A' }}>비밀번호</label>
              <input id="password" name="password" type="password" required placeholder="••••••••"
                className="w-full px-3 py-2 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                style={{ borderColor: '#E5E2D9', background: '#F8F8F5' }} />
            </div>
            {state?.error && (
              <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">
                {state.error === 'Invalid login credentials' ? '이메일 또는 비밀번호가 올바르지 않습니다.' : state.error}
              </p>
            )}
            <SubmitButton />
          </form>
        </div>

        <p className="text-center text-xs mt-4" style={{ color: '#9F9C90' }}>
          teacher@test.com / password123
        </p>
      </div>
    </main>
  )
}
